import clsx from 'clsx'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import type { IBCKSKepalaSekolahEligibility } from 'types/bcks'
import type { FC } from 'react'

export interface BannerQualificationProps {
  variant: IBCKSKepalaSekolahEligibility['status']
}

const TITLE_EMPTY = 'Belum ada data'
const DESCRIPTION_EMPTY =
  'Cek data yang perlu dilengkapi di bawah dan perbarui melalui operator dinas atau Dapodik.'

const TITLE_INVALID = 'Belum memenuhi kriteria'
const DESCRIPTION_INVALID =
  'Jika ada data yang salah atau belum diperbarui, silakan hubungi operator dinas atau Dapodik.'

const TITLE_VALID = 'Sudah memenuhi kriteria'
const DESCRIPTION_VALID =
  'Jika ada seleksi yang berlangsung, Anda akan mendapat undangan dari dinas setempat.'

const BannerQualification: FC<BannerQualificationProps> = ({
  variant = 'NOT_FOUND',
}) => {
  return (
    <div
      data-testid="banner-qualification"
      className={clsx({
        'border rounded px-4 py-6 text-center': true,
        '!bg-white !border-[#53575A]': variant === 'NOT_FOUND',
        '!bg-white !border-[#E02D38]': variant === 'INVALID',
        '!bg-[#ECFEF2] !border-[#4CA375]': variant === 'VALID',
      })}
    >
      {variant !== 'NOT_FOUND' && (
        <Icon
          data-testid="banner-qualification-icon"
          color={variant === 'VALID' ? 'success' : 'critical'}
          className="!text-[40px] !h-10 !w-10"
        >
          {variant === 'INVALID' && 'close'}
          {variant === 'VALID' && 'check_circle'}
        </Icon>
      )}
      <Text
        variant="heading-sm"
        color="subdued"
        className={clsx({
          'mb-2': true,
          '!text-[#2E8A5C]': variant === 'VALID',
        })}
      >
        {variant === 'NOT_FOUND' && TITLE_EMPTY}
        {variant === 'INVALID' && TITLE_INVALID}
        {variant === 'VALID' && TITLE_VALID}
      </Text>
      <Text
        variant="body-sm"
        color={variant === 'VALID' ? 'subdued' : 'disabled'}
      >
        {variant === 'NOT_FOUND' && DESCRIPTION_EMPTY}
        {variant === 'INVALID' && DESCRIPTION_INVALID}
        {variant === 'VALID' && DESCRIPTION_VALID}
      </Text>
    </div>
  )
}

export default BannerQualification
